import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import AuditService from '../../services/AuditService';

function AuditHistoryLink({ entityId, userRole, service = AuditService }) {
  const [allowed, setAllowed] = useState(false);
  useEffect(() => {
    let active = true;
    setAllowed(false);
    if (!entityId || !['ADMIN', 'OPERATOR'].includes(userRole)) return () => { active = false; };
    service.getCapabilities().then(result => { if (active) setAllowed(result.canRead === true); })
      .catch(() => { if (active) setAllowed(false); });
    return () => { active = false; };
  }, [entityId, userRole, service]);
  if (!allowed) return null;
  return <Link className="btn manage-teal-button" to={`/manage/audit?entityId=${encodeURIComponent(entityId)}`}>Historia zmian</Link>;
}

AuditHistoryLink.propTypes = {
  entityId: PropTypes.string,
  userRole: PropTypes.string,
  service: PropTypes.shape({ getCapabilities: PropTypes.func }),
};
AuditHistoryLink.defaultProps = { entityId: '', userRole: '', service: AuditService };

export default AuditHistoryLink;
